import { useNavigate } from 'react-router-dom';
import { usePageHistory } from '../../hooks/usePageHistory';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';

interface PageHistoryPanelProps {
  onClose: () => void;
}

export const PageHistoryPanel = ({ onClose }: PageHistoryPanelProps) => {
  const navigate = useNavigate();
  const { history, clearHistory } = usePageHistory();

  const handleNavigate = (path: string) => {
    navigate(path);
    onClose();
  };

  const handleClearHistory = () => {
    clearHistory();
    onClose();
  };

  return (
    <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900">Historique de navigation</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      </div>

      <div className="max-h-96 overflow-y-auto">
        {history.length === 0 ? (
          <div className="p-8 text-center">
            <i className="ri-history-line text-4xl text-gray-300 mb-2"></i>
            <p className="text-sm text-gray-500">Aucune page visitée récemment</p>
          </div>
        ) : (
          <div className="py-2">
            {history.map((entry, index) => (
              <button
                key={`${entry.path}-${entry.timestamp}`}
                onClick={() => handleNavigate(entry.path)}
                className="w-full px-4 py-3 flex items-start gap-3 hover:bg-gray-50 transition-colors text-left group"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg group-hover:bg-teal-50 transition-colors flex-shrink-0">
                  <i className={`${entry.icon} text-gray-600 group-hover:text-teal-600 transition-colors`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {entry.title}
                  </p>
                  <p className="text-xs text-gray-500 truncate">{entry.path}</p>
                  <p className="text-xs text-gray-400 mt-0.5">
                    {formatDistanceToNow(entry.timestamp, { 
                      addSuffix: true, 
                      locale: fr 
                    })}
                  </p>
                </div>
                <i className="ri-arrow-right-line text-gray-400 group-hover:text-teal-600 transition-colors flex-shrink-0"></i>
              </button>
            ))}
          </div>
        )}
      </div>

      {history.length > 0 && (
        <div className="p-3 border-t border-gray-200">
          <button
            onClick={handleClearHistory}
            className="w-full px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <i className="ri-delete-bin-line"></i>
            Effacer l'historique
          </button>
        </div>
      )}
    </div>
  );
};